import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Articles from './Articles';
import News from './News';
import Videos from './Videos';
import LandingPage from './LandingPage';

const PostManagementModule = () => {
  return (
    <div>
      <Suspense fallback={null}>
        <Routes>
          <Route path="articles" element={<Articles />} />
          <Route path="news" element={<Articles />} />
          <Route path="reports" element={<Articles />} />
          <Route path="webinars" element={<Articles />} />
          <Route path="interviews" element={<Articles />} />
          <Route path="whitePapers" element={<Articles />} />
          <Route path="videos" element={<Articles />} />
          <Route path="events" element={<Articles />} />
          <Route path="landingPage" element={<LandingPage />} />
        </Routes>
      </Suspense>
    </div>
  );
};

export default PostManagementModule;
